import { useEffect } from "react"
import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider"
import { useUserModalContext } from "../../../Contexts/UserModalContext/UserModalProvider"
import ViewCommentsOfNotice from "../../../Components/SharedComponents/ViewData/ViewCommentsOfNotice"
import ViewNoticeMainData from "../../../Components/SharedComponents/ViewData/ViewNoticeMainData"
import BackButton from "../../../Components/SharedComponents/OtherComponents/BackButton"
import LoadingInfo from "../../../Components/SharedComponents/OtherComponents/LoadingInfo"
import '../UserModalCSS.css'


function UserSeeNoticeModal() {

	const { appLocation } = useGeneralContext()
	const { noticeToSee, setNoticeToSee, allNotices, isFirstUpdate } = useUserModalContext()
	const noticeId = appLocation?.itemId
	const isShowingNoticeOfUrl = noticeToSee.SK === noticeId
	const noticeFromList = allNotices.find((notice) => notice.SK === noticeId)

	// Opening a notice from a list already selects it. This covers a reload or a link.
	useEffect(() => {
		if (!isShowingNoticeOfUrl && noticeFromList) {
			setNoticeToSee(noticeFromList)
		}
	}, [isShowingNoticeOfUrl, noticeFromList, setNoticeToSee])

	if (isShowingNoticeOfUrl) {
		return (
			<>
				<BackButton fallbackSection='NoticeList' />
				<ViewNoticeMainData/>
				<ViewCommentsOfNotice/>
			</>
		)
	}

	if (isFirstUpdate || noticeFromList) {
		return <LoadingInfo />
	}

	return (
		<div className="ItemNotFoundDiv">
			<h2>No encontramos este aviso.</h2>
			<BackButton fallbackSection='NoticeList' />
		</div>
	)
}

export default UserSeeNoticeModal
